import { useEffect } from "react";

/**
 * Setting コンポーネント
 * 設定
 * @returns React.ReactNode
 */
const Setting: React.FC = () => {

  /**
   * GoogleAnalytics用トラッキング
   */
  useEffect(() => {
    window.gtag !== undefined && window.gtag('config', `${process.env.REACT_APP_DEV_TRACKING_ID}`, { page_path: window.location.pathname });
  }, []);

  return (
    <>
    </>
  );
};

export default Setting;